import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMutation } from 'data-fetching-client';
import { addAlert } from '../../../utils/alerts';
import { useTracker } from '../../../utils/usageTracker';
import { PAUSE_SUBSCRIPTION } from './pauseSubscriptionApi';
import { useNotificationsQuery } from '../hooks/useNotificationsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function usePauseSubscription({
  objectId,
  internalNotes,
  onClose
}) {
  const {
    trackPauseChange
  } = useTracker();
  const {
    sendEmailForSubscriptionPaused
  } = useNotificationsQuery();
  return useMutation(PAUSE_SUBSCRIPTION, {
    variables: {
      objectId,
      pauseReason: internalNotes
    },
    fetchPolicy: 'network-only',
    onCompleted: () => {
      trackPauseChange({
        subType: 'pause',
        action: 'pauseSubscriptionModalSubmitted',
        status: 'PAUSED'
      });
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.successfullyPausedTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: sendEmailForSubscriptionPaused ? 'subscriptions.PauseSubscriptionModal.successfullyPausedMessageNotify' : 'subscriptions.PauseSubscriptionModal.successfullyPausedMessageNoNotify'
        }),
        type: 'success'
      });
      onClose();
    },
    onError: () => {
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.errorPausingTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.errorPausingMessage"
        }),
        type: 'danger'
      });
      onClose();
    }
  });
}